import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-tasklist",
  templateUrl: "./med-icon-tasklist.component.html",
})
export class MedIconTasklistComponent extends SvgMixinComponent {}
